//LIBRARIES
import { useTranslation } from "react-i18next";

export const FiltersComponentOptions = () => {
  const { t } = useTranslation();
  return {
    containerOptions: [
      {
        key: "Tulcea",
        value: "Tulcea",
      },
      {
        key: "Constanta",
        value: "Constanta",
      },
      {
        key: "Dunare",
        value: "Dunare",
      },
    ],

    rentalsTypeReportOptions: [
      {
        key: "Zilnic",
        value: t("filtersComponent.reportTypeOptions.daily"),
      },
      {
        key: "Saptamanal",
        value: t("filtersComponent.reportTypeOptions.weekly"),
      },
      {
        key: "Lunar",
        value: t("filtersComponent.reportTypeOptions.monthly"),
      },
      {
        key: "Anual",
        value: t("filtersComponent.reportTypeOptions.yearly"),
      },
    ],

    usersTypeReportOptions: [
      {
        key: "Zilnic",
        value: t("filtersComponent.reportTypeOptions.daily"),
      },
      {
        key: "Saptamanal",
        value: t("filtersComponent.reportTypeOptions.weekly"),
      },
      {
        key: "Lunar",
        value: t("filtersComponent.reportTypeOptions.monthly"),
      },
      {
        key: "Anual",
        value: t("filtersComponent.reportTypeOptions.yearly"),
      },
    ],

    paymentsTypeReportOptions: [
      {
        key: "Zilnic",
        value: t("filtersComponent.reportTypeOptions.daily"),
      },
      {
        key: "Saptamanal",
        value: t("filtersComponent.reportTypeOptions.weekly"),
      },
      {
        key: "Lunar",
        value: t("filtersComponent.reportTypeOptions.monthly"),
      },
      {
        key: "Anual",
        value: t("filtersComponent.reportTypeOptions.yearly"),
      },
    ],

    invoicesTypeReportOptions: [
      {
        key: "Zilnic",
        value: t("filtersComponent.reportTypeOptions.daily"),
      },
      {
        key: "Saptamanal",
        value: t("filtersComponent.reportTypeOptions.weekly"),
      },
      {
        key: "Lunar",
        value: t("filtersComponent.reportTypeOptions.monthly"),
      },
      {
        key: "Anual",
        value: t("filtersComponent.reportTypeOptions.yearly"),
      },
    ],

    statusOptions: [
      {
        key: "Acceptat",
        value: t("page.reportDetails.statusOptions.accepted"),
      },
      {
        key: "Neacceptat",
        value: t("page.reportDetails.statusOptions.rejected"),
      },
      {
        key: "In asteptare",
        value: t("page.reportDetails.statusOptions.onHold"),
      },
    ],

    usersStatusOptions: [
      {
        key: "VERIFIED",
        value: t("filtersComponent.userStatusOptions.verified"),
      },
      {
        key: "ACTIVE",
        value: t("filtersComponent.userStatusOptions.active"),
      },
      {
        key: "INACTIVE",
        value: t("filtersComponent.userStatusOptions.inactive"),
      },
      {
        key: "BLACKLIST",
        value: t("filtersComponent.userStatusOptions.blacklist"),
      },
      {
        key: "VERIFICATION_IN_PROGRESS",
        value: t("filtersComponent.userStatusOptions.verificationInProgress"),
      },
      {
        key: "DEACTIVATED",
        value: t("filtersComponent.userStatusOptions.deactivated"),
      },
      {
        key: "BLOCKED",
        value: t("filtersComponent.userStatusOptions.blocked"),
      },
      {
        key: "REJECTED",
        value: t("filtersComponent.userStatusOptions.rejected"),
      },
      {
        key: "MINOR",
        value: t("filtersComponent.userStatusOptions.minor"),
      },
    ],
    promoCodeTypeOptions: [
      {
        key: "FIXED",
        value: "Fixed discount"
      },
      {
        key: "PERCENTAGE",
        value: "Percentage",
      },
    ],
  };
};
